'use strict';

import angular from 'angular';
import Admin from './admin.controller';

export default angular.module('aperamApp.borne.admin', [])
  .controller('AdminController', Admin)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/admin/index.js